import { render } from "./Farmer.vue?vue&type=template&id=6ef7bbba&scoped=true&ts=true"
import script from "./Farmer.vue?vue&type=script&lang=ts"
export * from "./Farmer.vue?vue&type=script&lang=ts"

import "./Farmer.vue?vue&type=style&index=0&id=6ef7bbba&lang=css"
import "./Farmer.vue?vue&type=style&index=1&id=6ef7bbba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef7bbba"]])

export default __exports__